import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CalendarBarComponent } from './calendar-bar/calendar-bar.component'
import { BaseImageComponent } from './base-image/base-image.component'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { ImageProgressComponent } from './image-progress/image-progress.component'
import { DatePickerComponent } from './date-picker/date-picker.component'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ImageComponent } from './image/image.component'
import { OButtonModule } from '@commons/o-button/o-button.module'
import { BaseVideoComponent } from './base-video/base-video.component'
import { SimpleImageComponent } from './simple-image/simple-image.component'
import { UploadFileComponent } from './upload-file/upload-file.component'
import { ShowBigImageComponent } from './show-big-image/show-big-image.component'
import { ThumbnailVideoComponent } from './thumbnail-video/thumbnail-video.component'
import { PipeModule } from '@app/pipes/pipe.module'
import { ImageUploadComponent } from './image-upload/image-upload.component'
import { InputFieldComponent } from './input-field/input-field.component'
import { ControlMessagesComponent } from './control-messages/control-messages.component'
import { BasePdfComponent } from './base-pdf/base-pdf.component'
import { BaseReactionComponent } from './base-reaction/base-reaction.component'

const COMMONS = [
    CalendarBarComponent,
    BaseImageComponent,
    ImageProgressComponent,
    DatePickerComponent,
    ImageComponent,
    SimpleImageComponent,
    UploadFileComponent,
    BaseVideoComponent,
    BasePdfComponent,
    ShowBigImageComponent,
    ThumbnailVideoComponent,
    ImageUploadComponent,
    InputFieldComponent,
    ControlMessagesComponent,
]

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgCircleProgressModule.forRoot(),
        A2Edatetimepicker,
        ReactiveFormsModule,
        PipeModule,
    ],
    declarations: [
        ...COMMONS,
        BaseReactionComponent,

    ],
    exports: [
        OButtonModule,
        ...COMMONS,
        BaseReactionComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonsModule {
}



// WEBPACK FOOTER //
// ./src/app/commons/commons.module.ts